'use strict'

let self

export default self = {
  container : document.getElementById('marketReport'),

  init : () => {
    self.setupElements()
    self.registerEvents()

    if ( self.nav ) self.nav.querySelector('button').click()

    const reportVideos = [...document.querySelectorAll('.reports-lists .col-2.has-video')]
    reportVideos.map( report => report.addEventListener('click', self.toggleReportVideo) )
  },

  toggleReportVideo : e => {
    const report = e.currentTarget
    if ( report.classList.contains('video-playing') ) return false

    report.classList.toggle('video-playing')
    report.querySelector('video').play()
  },

  setupElements : () => {
    self.tabs = self.container.querySelector('.tabs')
    self.nav = self.container.querySelector('.tab-nav')
    self.sidebarButtons = [...document.querySelectorAll(`.tab-sidebar button`)]
    self.mapTriggers = [...self.container.querySelectorAll('svg .map-trigger')]
  },

  registerEvents : () => {
    if ( self.nav ) self.nav.addEventListener('click', self.change)
    if ( self.mapTriggers ) self.mapTriggers.forEach( trigger => trigger.addEventListener('click', self.changeFromMapTrigger) )
    if ( self.sidebarButtons ) self.sidebarButtons.forEach( button => button.addEventListener('click', self.changeGraph) )
  },

  changeFromMapTrigger : e => {
    const group = e.currentTarget
    const rel = group.getAttribute('rel')

    return self.nav.querySelector(`button[rel="${rel}"]`).click()
  },

  change : e => {
    if (e.target.nodeName !== 'BUTTON') return false
    const button = e.target
    const rel = button.getAttribute('rel')
    const activeButton = self.nav.querySelector('.active')
    const selectedTab = self.tabs.querySelector(`.tab[rel=${rel}]`)
    const activeTab = self.tabs.querySelector(`.tab.active`)

    if (activeButton) activeButton.classList.remove('active')
    button.classList.add('active')

    if (activeTab) activeTab.classList.remove('active')
    selectedTab.classList.add("active")

    self.sidebarButtons.map( button => {
      if ( button.getAttribute('rel') === rel ) {
        button.classList.add('show')
      } else {
        button.classList.remove('show')
      }
    })

    document.querySelector(`.tab-sidebar button.show`).click()
  },

  changeGraph : e => {
    const button = e.currentTarget
    const index = button.getAttribute('data-index')
    const activeButton = document.querySelector(`.tab-sidebar button.active`)
    const activeGraph = self.tabs.querySelector(`.graph-container article.active`)
    const targetArticle = self.tabs.querySelector(`article[data-index="${index}"]`)

    if ( activeButton ) activeButton.classList.remove('active')
    button.classList.add('active')

    if ( activeGraph ) activeGraph.classList.remove('active')
    targetArticle.classList.add('active')

    self.loadGraph({ article : targetArticle })
  },

  loadGraph : ({ article }) => {
    const iframe = article.querySelector('iframe')
    const src = iframe.getAttribute('data-src')

    if ( src ) {
      iframe.src = src
      iframe.removeAttribute( 'data-src' )
    }
  },

}
